var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import axios from 'axios';
import { Ajax } from '@/common';
import { getVideoMetadata, transcodeVideoForUpload } from '@/views/moments/modules/videoTranscode';
var _a = require('./videoUploadCore'), buildOssCanonicalHeaders = _a.buildOssCanonicalHeaders, buildOssStringToSign = _a.buildOssStringToSign, buildOssUploadUrl = _a.buildOssUploadUrl, createVideoUploadPipeline = _a.createVideoUploadPipeline, isSupportedVideoFile = _a.isSupportedVideoFile, isValidVideoDuration = _a.isValidVideoDuration, MAX_ANNOUNCEMENT_VIDEO_TOTAL_SIZE = _a.MAX_ANNOUNCEMENT_VIDEO_TOTAL_SIZE;
/**
 * Bridges an AbortSignal onto an axios CancelToken.
 *
 * axios@0.21 (the version this project installs) has no `signal` option — neither in its
 * type definitions nor at runtime — so passing `signal` through would both fail the build
 * and silently skip cancellation. CancelToken is what 0.21 understands, and it is already
 * the convention used elsewhere in this repo (see `views/journal/template/select.vue`).
 */
var toCancelToken = function (signal) {
    if (!signal) {
        return {};
    }
    var source = axios.CancelToken.source();
    var cancelUpload = function () { return source.cancel('Upload stopped'); };
    if (signal.aborted) {
        cancelUpload();
    }
    else {
        signal.addEventListener('abort', cancelUpload, { once: true });
    }
    return { cancelToken: source.token };
};
var ensureUploadActive = function (options) {
    if (options.signal && options.signal.aborted) {
        throw new Error('Upload stopped');
    }
    if (options.stopRequested && options.stopRequested()) {
        throw new Error('Upload stopped');
    }
};
var arrayBufferToBase64 = function (buffer) {
    var binary = '';
    var bytes = new Uint8Array(buffer);
    for (var index = 0; index < bytes.byteLength; index += 1) {
        binary += String.fromCharCode(bytes[index]);
    }
    return window.btoa(binary);
};
var signOssString = function (secret, message) { return __awaiter(void 0, void 0, void 0, function () {
    var encoder, cryptoKey, signature;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!window.crypto || !window.crypto.subtle || typeof TextEncoder === 'undefined') {
                    throw new Error('Current browser does not support OSS upload');
                }
                encoder = new TextEncoder();
                return [4 /*yield*/, window.crypto.subtle.importKey('raw', encoder.encode(secret), {
                        name: 'HMAC',
                        hash: { name: 'SHA-1' }
                    }, false, ['sign'])];
            case 1:
                cryptoKey = _a.sent();
                return [4 /*yield*/, window.crypto.subtle.sign('HMAC', cryptoKey, encoder.encode(message))];
            case 2:
                signature = _a.sent();
                return [2 /*return*/, arrayBufferToBase64(signature)];
        }
    });
}); };
var requestVideoUploadSts = function (originalFileName, options) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ensureUploadActive(options);
                return [4 /*yield*/, Ajax.post('/media/public/file/video/sts', { originalFileName: originalFileName }, __assign({}, toCancelToken(options.signal)))];
            case 1:
                response = _a.sent();
                if (!response || response.code !== '0000' || !response.data) {
                    throw new Error((response && response.message) || 'Failed to get video upload STS');
                }
                return [2 /*return*/, response.data];
        }
    });
}); };
var putVideoToOss = function (file, stsData, onProgress, options) { return __awaiter(void 0, void 0, void 0, function () {
    var requestDate, contentType, stringToSign, signature, response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ensureUploadActive(options);
                requestDate = new Date().toUTCString();
                contentType = file.type || 'video/mp4';
                stringToSign = buildOssStringToSign({
                    bucketName: stsData.bucketName,
                    objectKey: stsData.objectKey,
                    contentType: contentType,
                    requestDate: requestDate,
                    securityToken: stsData.securityToken
                });
                return [4 /*yield*/, signOssString(stsData.accessKeySecret, stringToSign)];
            case 1:
                signature = _a.sent();
                return [4 /*yield*/, axios.put(buildOssUploadUrl(stsData), file, __assign(__assign({}, toCancelToken(options.signal)), { headers: {
                            'Content-Type': contentType,
                            'x-oss-date': requestDate,
                            'x-oss-security-token': stsData.securityToken,
                            Authorization: "OSS ".concat(stsData.accessKeyId, ":").concat(signature)
                        }, onUploadProgress: function (progressEvent) {
                            var progress = progressEvent.total ? (progressEvent.loaded / progressEvent.total) * 100 : 0;
                            onProgress(progress);
                        } }))];
            case 2:
                response = _a.sent();
                return [2 /*return*/, {
                        etag: response.headers && response.headers.etag
                    }];
        }
    });
}); };
var completeVideoUpload = function (payload, options) { return __awaiter(void 0, void 0, void 0, function () {
    var response;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                ensureUploadActive(options);
                return [4 /*yield*/, Ajax.post('/media/public/file/video/complete', payload, __assign({}, toCancelToken(options.signal)))];
            case 1:
                response = _a.sent();
                if (!response || response.code !== '0000' || !response.data) {
                    throw new Error((response && response.message) || 'Failed to complete video upload');
                }
                return [2 /*return*/, response.data];
        }
    });
}); };
var uploadPipeline = createVideoUploadPipeline({
    fileBaseUrl: process.env.VUE_APP_fileBasePath,
    getDuration: function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var metadata;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, getVideoMetadata(file)];
                case 1:
                    metadata = _a.sent();
                    return [2 /*return*/, metadata.duration];
            }
        });
    }); },
    transcode: function (file, onProgress, options) { return __awaiter(void 0, void 0, void 0, function () {
        var result;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, transcodeVideoForUpload({
                        file: file,
                        stopRequested: function () {
                            return Boolean((options.signal && options.signal.aborted) ||
                                (options.stopRequested && options.stopRequested()));
                        },
                        onProgress: function (_a) {
                            var progress = _a.progress;
                            return onProgress(progress);
                        }
                    })];
                case 1:
                    result = _a.sent();
                    return [2 /*return*/, result.file];
            }
        });
    }); },
    requestSts: requestVideoUploadSts,
    putFile: putVideoToOss,
    complete: completeVideoUpload
});
export function validateAnnouncementVideoSelection(files) {
    return __awaiter(this, void 0, void 0, function () {
        var selection, unsupportedFile, durationErrors, _i, selection_1, file, metadata, error_1, filesWithSizes, totalSize;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    selection = Array.isArray(files) ? files : [];
                    unsupportedFile = selection.find(function (file) { return !isSupportedVideoFile(file); });
                    if (unsupportedFile) {
                        throw new Error("".concat(unsupportedFile.name || 'The selected video', " format is not supported"));
                    }
                    durationErrors = [];
                    _i = 0, selection_1 = selection;
                    _a.label = 1;
                case 1:
                    if (!(_i < selection_1.length)) return [3 /*break*/, 6];
                    file = selection_1[_i];
                    _a.label = 2;
                case 2:
                    _a.trys.push([2, 4, , 5]);
                    return [4 /*yield*/, getVideoMetadata(file)];
                case 3:
                    metadata = _a.sent();
                    if (!isValidVideoDuration(metadata.duration)) {
                        durationErrors.push({
                            name: file.name || 'Unknown file',
                            duration: Number.isFinite(metadata.duration) ? metadata.duration : null
                        });
                    }
                    return [3 /*break*/, 5];
                case 4:
                    error_1 = _a.sent();
                    durationErrors.push({
                        name: file.name || 'Unknown file',
                        duration: null
                    });
                    return [3 /*break*/, 5];
                case 5:
                    _i++;
                    return [3 /*break*/, 1];
                case 6:
                    filesWithSizes = selection.map(function (file) { return ({
                        name: file.name || 'Unknown file',
                        size: Number(file.size) || 0
                    }); });
                    totalSize = filesWithSizes.reduce(function (sum, file) { return sum + file.size; }, 0);
                    return [2 /*return*/, {
                            durationErrors: durationErrors,
                            totalSizeError: totalSize > MAX_ANNOUNCEMENT_VIDEO_TOTAL_SIZE
                                ? {
                                    totalSize: totalSize,
                                    files: filesWithSizes
                                }
                                : null
                        }];
            }
        });
    });
}
export function uploadAnnouncementVideo(file_1) {
    return __awaiter(this, arguments, void 0, function (file, options) {
        if (options === void 0) { options = {}; }
        return __generator(this, function (_a) {
            if (typeof navigator !== 'undefined' && /firefox/i.test(navigator.userAgent || '')) {
                throw new Error('Video upload is only supported in Chrome and Chromium-based browsers.');
            }
            if (file.size > MAX_ANNOUNCEMENT_VIDEO_TOTAL_SIZE) {
                throw new Error('The selected video exceeds the maximum limit of 500MB.');
            }
            return [2 /*return*/, uploadPipeline(file, options)];
        });
    });
}
export { buildOssCanonicalHeaders };
